import {TrackingEvent as TableTrackingEvent} from 'common/components/table/tracking';
import {BrowseTrackedEvent} from 'common/report/util/search/tracking';

export const CAPTURED_TRACKING = new Set<string>([
  `[mp-table] ${TableTrackingEvent.SortChange}`,
  ...Object.values(BrowseTrackedEvent),
  `Selected Entity to Create`,
]);
